const CONDITION_OPTIONS = [
    {label: 'new', value: 'new'},
    {label: 'used', value: 'used'}
];
const CONDITION_OPTIONS_MAP = CONDITION_OPTIONS.reduce((acc, item) => {
    acc[item.value] = item
    return acc;
}, {});

const QUALITY_OPTIONS = [
    {label: 'original', value: 'original'},
    {label: 'oem', value: 'oem'},
    {label: 'aftermarket', value: 'aftermarket'}
];
const QUALITY_OPTIONS_MAP = QUALITY_OPTIONS.reduce((acc, item) => {
    acc[item.value] = item
    return acc;
}, {});

const REPAIR_STATES_MAP = {
    PENDING: 'pending',
    IN_PROGRESS: 'in_progress',
    COMPLETED: 'completed',
    CANCELLED: 'cancelled',
    CUSTOMER_REFUSED: 'customerRefused',
    TECHNICIAN_REFUSED: 'technicianRefused',
    PAUSED: 'paused',
    WAITING_PARTS: 'waiting_parts',
    WAITING_CUSTOMER: 'waiting_customer',
    WAITING_EXTERNAL: 'waiting_external',
    BLOCKED: 'blocked',
    NOT_REPAIRABLE: 'not_repairable',
};
const CANCEL_REPAIR_ALLOWED_STATES = [REPAIR_STATES_MAP.PENDING, REPAIR_STATES_MAP.IN_PROGRESS];
const START_REPAIR_ALLOWED_STATES = [REPAIR_STATES_MAP.PENDING, REPAIR_STATES_MAP.IN_PROGRESS];

export {
    CONDITION_OPTIONS,
    QUALITY_OPTIONS,
    QUALITY_OPTIONS_MAP,
    CONDITION_OPTIONS_MAP,
    CANCEL_REPAIR_ALLOWED_STATES,
    START_REPAIR_ALLOWED_STATES,
    REPAIR_STATES_MAP
}
